import React from "react";
import { ReactComponent as NotificationIcon } from "../../assets/icons/notifications_page.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { savePathToLocalStorage } from "../../utils/helpers";
import { useNotifications, useNotification } from "../../Api/newSockets.api";

const NotificationsPage = () => {
  const { notifications } = useNotifications();
  const { readNotification, markAllRead, clearAll } = useNotification();

  const handleReadNotification = (notificationId) => {
    readNotification(notificationId);
  };

  const convertDate = (date) => {
    const newDate = new Date(date);
    return newDate.toLocaleString();
  };

  const hasNotifications = notifications && notifications.notifications?.length > 0;
  const hasUnread = notifications && notifications.unreadNotificationsCount > 0;

  savePathToLocalStorage();
  return (
    <div className="notification">
      <div className="notifications-header">
        <p>Notifications</p>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          {hasNotifications && (
            <>
              <button
                onClick={() => markAllRead()}
                disabled={!hasUnread}
                style={{
                  background: "transparent",
                  border: "1px solid rgba(83, 189, 228, 0.5)",
                  color: hasUnread ? "#53bde4" : "#666",
                  padding: "0.5rem 1rem",
                  borderRadius: "6px",
                  fontSize: "0.85rem",
                  cursor: hasUnread ? "pointer" : "default",
                  opacity: hasUnread ? 1 : 0.5,
                }}
              >
                Mark all as read
              </button>
              <button
                onClick={() => clearAll()}
                style={{
                  background: "transparent",
                  border: "1px solid rgba(255, 107, 107, 0.5)",
                  color: "#ff6b6b",
                  padding: "0.5rem 1rem",
                  borderRadius: "6px",
                  fontSize: "0.85rem",
                  cursor: "pointer",
                }}
              >
                Clear all
              </button>
            </>
          )}
          <NotificationIcon />
        </div>
      </div>
      <div className="notifications-body">
        <div className="notifications-content">
          {notifications && notifications.notifications.length === 0 && (
            <div style={{ padding: "2rem", color: "#6c757d", textAlign: "center" }}>
              No notifications
            </div>
          )}
          {notifications &&
            notifications.notifications.map((data) => (
              <div
                className="notification-box"
                style={{ opacity: data.readStatus ? 0.5 : 1 }}
                key={data.id}
                onClick={() => handleReadNotification(data.id)}
              >
                <div className="notification-box-icon">
                  <SettingsIcon className="system" />
                </div>
                <div className="notification-box-data">
                  <p className="title">{data.title}</p>
                  <p className="description">{data.description}</p>
                  <p className="time">{convertDate(data.dateCreated)}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
